import React from 'react';
import { VpSticker, type VpStickerProps } from '@vtmn-play/react';
import { type PropsWithChildren } from 'react';

interface LabelProps extends PropsWithChildren, VpStickerProps {}

export const Label = ({ children, ...rest }: LabelProps) => {
  return <VpSticker {...rest}>{children}</VpSticker>;
};
